import React from "react";
import { getDate } from "utils/formatDate";
import Pagination from "react-js-pagination";
import { formatNumber } from "utils/currencyFormat";

class LichSuNoPhaiThuView extends React.Component {
  constructor(props) {
    super(props);
    let isShow = true;
    let displayText = "contents";
    if (matchMedia) {
      var mq = window.matchMedia("(max-width: 768px)");
      isShow = !mq.matches;
      if (mq.matches) displayText = "block";
    }
    this.state = {
      text1: "",
      itemShow: {
        item: null,
        isShow: isShow,
        displayText,
      },
    };
  }
  showRow = (item) => () => {
    let { itemShow } = this.state;
    let isShow = true;
    if (matchMedia) {
      var mq = window.matchMedia("(max-width: 768px)");
      isShow = mq.matches && !itemShow.isShow;
    }
    itemShow.item = item;
    itemShow.isShow = isShow;
    this.setState({ itemShow });
  };
  renderRow(List) {
    let { pageIndex, pageSize } = this.props;
    return List.map((item, index) => {
      let { CreatedTime, Time, TimeMustPay, Value, Note } = item;
      return (
        <tr key={"lsGiaHanNoPhaThu" + index}>
          <td>{index + 1 + (pageIndex - 1) * pageSize}</td>
          <td>{getDate(Time)}</td>
          <td>{getDate(CreatedTime)}</td>
          <td>{getDate(TimeMustPay)}</td>
          <td className="text-right">{formatNumber(Value)}</td>
          <td className="text-left">{Note}</td>
        </tr>
      );
    });
  }
  render() {
    let {
      List,
      pageIndex,
      pageSize,
      TotalQuantity,
      TongTien,
      handlePageChange,
    } = this.props;
    return (
      <div className="table-from-detailtl4">
        <div className="Left808x200  Table-main-morman table-noboder-new">
          <div className="table-responsive table-new1">
            <table
              className="table table-bordered table-hover table-rounded"
              style={{ marginTop: "20px" }}
            >
              <thead>
                <tr>
                  <th className="w-stt">
                    <span className="color-do-bold">[{TotalQuantity}]</span>
                  </th>
                  <th>
                    Gia hạn cho kỳ
                    <br />
                    &nbsp;
                  </th>
                  <th>
                    Ngày gia hạn
                    <br />
                    &nbsp;
                  </th>
                  <th>
                    Ngày phải thanh toán
                    <br />
                    &nbsp;
                  </th>
                  <th className="text-right">
                    Số tiền phải thanh toán
                    <br /> <i className="la la-dollar color-do-bold"></i>
                    <span className="color-do-bold">
                      = {formatNumber(TongTien)}
                    </span>
                  </th>
                  <th className="text-left">
                    Lý do gia hạn
                    <br />
                    &nbsp;
                  </th>
                </tr>
              </thead>
              <tbody>{this.renderRow(List)}</tbody>
            </table>
          </div>
        </div>
        {TotalQuantity > pageSize && (
          <div className="footer-page-new">
            <div className="col-xl-12 col-lg-12">
              <div class="paniation-new d-flex just-end">
                <nav aria-label="Page navigation">
                  <Pagination
                    activePage={pageIndex}
                    itemsCountPerPage={pageSize}
                    totalItemsCount={TotalQuantity}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    itemClass="page-item border-none"
                    linkClass="page-link border-none"
                    activeClass="active"
                  />
                </nav>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
export default LichSuNoPhaiThuView;
